import { useState, useEffect } from "react";
import MainLayout from "@/components/layout/MainLayout";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import { ClipboardCheck, ExternalLink, Link2, FileText } from "lucide-react";
import { STATUS_ROMANEIO, fmtDataBR, linkConferencia } from "./constants";

export default function ConferenciaPage() {
  const [romaneios, setRomaneios] = useState([]);
  useEffect(() => {
    axios.get(`${API}/logistica/romaneios`).then(r =>
      setRomaneios(r.data.filter(x => ["em_transito", "nao_confirmado"].includes(x.status)))).catch(() => {});
  }, []);

  return (
    <MainLayout>
      <div className="space-y-4" data-testid="conferencia-page">
        <div>
          <h1 className="text-2xl font-bold text-luvcorp-navy flex items-center gap-2">
            <ClipboardCheck className="h-6 w-6 text-luvcorp-gold" /> Conferência de Entregas
          </h1>
          <p className="text-sm text-slate-500">Romaneios em trânsito aguardando conferência na obra. O recebedor usa o QR do FL-05 impresso — <b>não precisa de login</b>.</p>
        </div>
        <Card className="border-0 shadow-sm">
          <CardContent className="p-0">
            {romaneios.length === 0 ? (
              <p className="px-4 py-10 text-center text-slate-400 text-sm">Nenhum romaneio em trânsito.</p>
            ) : romaneios.map((r) => {
              const st = STATUS_ROMANEIO[r.status] || {};
              return (
                <div key={r.id} className="flex items-center justify-between gap-2 px-4 py-3 border-b border-slate-100 flex-wrap" data-testid={`conferencia-row-${r.numero}`}>
                  <div>
                    <p className="font-semibold text-luvcorp-navy">{r.numero} — {r.obra_titulo}</p>
                    <p className="text-xs text-slate-500">Entrega {fmtDataBR(r.data_entrega)} · {r.veiculo_placa} · {r.condutor_nome}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge variant="outline" className={st.cls}>{st.label}</Badge>
                    <Button variant="outline" size="sm" onClick={() => { navigator.clipboard.writeText(linkConferencia(r.conferencia_token || r.id)); toast.success("Link copiado"); }}>
                      <Link2 className="h-4 w-4" />
                    </Button>
                    <Button size="sm" className="bg-luvcorp-navy text-white" onClick={() => window.open(linkConferencia(r.conferencia_token || r.id), "_blank")} data-testid={`btn-abrir-conferencia-${r.numero}`}>
                      <ExternalLink className="h-4 w-4 mr-1" /> Conferir
                    </Button>
                    <Button size="sm" variant="outline" onClick={() => (window.location.href = `/logistica/conferencia-papel/${r.id}`)} data-testid={`btn-papel-${r.numero}`}>
                      <FileText className="h-4 w-4 mr-1" /> Lançar do papel
                    </Button>
                  </div>
                </div>
              );
            })}
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
}
